<template>
  <div class="vcl-logon__reset-password">
    <vp-icon
      icon="close"
      class="vcl-logon__close-button"
      @click="close"
    />
    <h3 class="vcl-logon__title">{{ $t('resetPassword') }}</h3>
    <p
      class="vcl-logon__description"
      style="margin-bottom: 27px"
    >
      {{ $t('resetPasswordMessage') }} <a href="mailto:support@virtual-peaker.com" class="vcl-logon__link">support@virtual-peaker.com</a>.
    </p>
    <vp-input
      v-model="email"
      class="mb19"
      autofocus
      width="100%"
      height="50px"
      :placeholder="$t('enterEmail')" type="email"
      required
      :styles="inputStyles"
    >
      <template #label>{{ $t('email') }}</template>
    </vp-input>
    <vp-button
      class="reset-password primary large vcl-logon__button"
      :disabled="!email"
      :styles="buttonStyles"
      @click="reset"
    >
      {{ $t('resetPassword') }}
    </vp-button>
  </div>
</template>

<script>
// General Components
import VpIcon from '../../components/vp-icon/VpIcon.vue';
import VpInput from '../../components/vp-input/VpInput.vue';
import VpButton from '../../components/vp-button/VpButton.vue';

export default {
  name: 'VpResetPassword',
  components: {
    VpIcon,
    VpInput,
    VpButton,
  },
  inject: ['$busy'],
  props: {
    styles: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      email: null,
    };
  },
  computed: {
    inputStyles() {
      return this.styles.input || {};
    },
    buttonStyles() {
      return this.styles.button || {};
    }
  },
  created() {
    window.addEventListener('keyup', this.keyListener);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.keyListener);
  },
  mounted() {
    this.$busy.on(false);
  },
  methods: {
    reset() {
      this.$busy.on(true);
      const { logon } = this.$deps;

      let delivery = 'web-pro_password-reset';
      if (this.app === 'admin') {
        delivery = 'web-admin_password-reset';
      } else if (this.app === 'gravity') {
        delivery = 'web-gravity_password-reset';
      } else if (this.app === 'home') {
        const byodConfig = JSON.parse(localStorage.getItem('proByodConfig')) || {};
        const { id: providerId = 1 } = byodConfig;
        delivery = `web-house-password-reset-${providerId}`;
      }

      return logon.resetPassword({ email: this.email, delivery })
        .then(() => {
          this.$router.push('/logon');
        })
        .catch(() => {
          return this.$router.push('/logon/error');
        })
        .finally(() => {
          this.$busy.on(false);
        });
    },
    close() {
      return this.$router.push('/logon#password');
    },
    keyListener(event) {
      if (event.key === 'Enter' && this.email) {
        return this.reset();
      }

      if (event.key === 'Escape') {
        return this.close();
      }

      return null;
    },
  }
};
</script>

<style>

</style>
